import { useParams } from "react-router";
import { PersistenceStateUsingContext } from "@/shared/persistence-state/persistence-state-info";
import { InspectionPdf } from "@/routes/processes/[processId]/process/inspections/[reportId]/_components/inspection-pdf";
import {
  ArtefactPage,
  ArtefactPageActions,
  ArtefactPageContent,
  ArtefactPageHeader,
  ArtefactPageNavigation,
  ArtefactPageNavigationLink,
  ArtefactPageNavigationOutlet,
} from "@/shared/service-manager/default-ui/artefact-page/artefact-page";
import {
  InspectionRule,
  useGetInspectionRulesQuery,
} from "@/services/backend/rules/service";
import { CreateCorrectionButton } from "./_components/create-correction-button";
import { ArtefactNotReadyAlert } from "@/shared/service-manager/artefact/artefact-sheet";
import { useErrArtefactNotReady } from "@/shared/service-manager/artefact/err-artefact-not-ready";

const links = [
  {
    to: "metadata",
    label: "Metadaten",
  },
  {
    to: "results",
    label: "Ergebnisse",
  },
  {
    to: "countings",
    label: "Zählungen",
  },
  {
    to: "differentiation",
    label: "Differenzierung",
  },
  {
    to: "contacts",
    label: "Kontakt",
  },
  {
    to: "customers",
    label: "Kundendaten",
  },
  {
    to: "company",
    label: "Prüflabor",
  },
];

function createTabs(rule: InspectionRule): { to: string; label: string }[] {
  const filteredNavigation = links.filter((item) => {
    if (item.to === "differentiation") return rule.hasDifferentiation;
    return true;
  });
  return filteredNavigation;
}

export function ReportRoute() {
  const { processId, reportId } = useParams();
  const { data: rule } = useGetInspectionRulesQuery({ processId: processId! });
  const { notReadyError } = useErrArtefactNotReady();

  if (!rule) {
    return null;
  }

  return (
    <ArtefactPage>
      <ArtefactPageHeader>
        <ArtefactPageNavigation>
          {createTabs(rule).map((link) => (
            <ArtefactPageNavigationLink key={link.to} to={link.to}>
              {link.label}
            </ArtefactPageNavigationLink>
          ))}
        </ArtefactPageNavigation>
        <ArtefactPageActions>
          <PersistenceStateUsingContext className="mr-2" />
          <InspectionPdf inspectionId={reportId!} />
          <CreateCorrectionButton reportId={reportId!} processId={processId!} />
        </ArtefactPageActions>
      </ArtefactPageHeader>
      <ArtefactPageContent>
        <ArtefactNotReadyAlert error={notReadyError} artefact="Inspektion" />
        <ArtefactPageNavigationOutlet />
      </ArtefactPageContent>
    </ArtefactPage>
  );
}
